export default __webpack_public_path__ + "static/media/Vambraces of the Usurper.689895ae.jpg";